export default __webpack_public_path__ + "static/media/login.21854c31.svg";